import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';
import { RouteName, routeTo } from '@/router/routes';
import { isSeriesCategory, SeriesResponse } from '@/types/cms';
import TG4Image from '@/components/TG4Image.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SeriesCell',
  props: {
    series: null,
    boxset: { type: Boolean },
    overlay: { type: Boolean },
    dynamicWidth: { type: Boolean },
    showCategory: { type: Boolean, default: false },
    textColor: null
  },
  setup(__props: any) {

const props = __props as { series: SeriesResponse, boxset?: boolean, overlay?: boolean, dynamicWidth?: boolean, showCategory: boolean, textColor?: string };



const instance = getCurrentInstance();
const router = instance?.proxy?.$router;

const navigateToSeries = () => {
  router?.push(routeTo(RouteName.Series, { slugOrVID: props.series.slug }));
};

const image = computed(() => (props.boxset ? props.series.boxsetImage : props.series.mainImage));

const categoryKey = computed(() => {
  const raw = props.series.rawCategory;
  return isSeriesCategory(raw) ? `category.${raw}` : null;
});

const textStyle = computed(() => {
  if (props.textColor) {
    return {
      color: props.textColor,
    };
  }
  return {};
});


return { __sfc: true,props, instance, router, navigateToSeries, image, categoryKey, textStyle, TG4Image }
}

})